import { useCallback } from 'react';
import { useTutorial } from '../context/TutorialContext';
import { getTutorialConfig } from '../config/tutorials.config';

/**
 * Hook to easily trigger tutorials from feature components
 * Usage:
 *   const triggerTutorial = useTutorialTrigger();
 *   triggerTutorial('ai_chat');
 */
export const useTutorialTrigger = () => {
  const { checkAndShowTutorial, trackFeatureUsage } = useTutorial();

  const triggerTutorial = useCallback(async (featureId) => {
    const config = getTutorialConfig(featureId);
    if (!config) {
      console.warn(`No tutorial config found for feature: ${featureId}`);
      return false;
    }

    return await checkAndShowTutorial(featureId, {
      title: config.title,
      description: config.description,
      videoSrc: config.videoSrc,
      transcript: config.transcript,
      nextFeature: config.nextFeature
    });
  }, [checkAndShowTutorial]);

  return {
    triggerTutorial,
    trackFeatureUsage
  };
};

export default useTutorialTrigger;

